import { render, staticRenderFns } from "./orderDetail.vue?vue&type=template&id=7eefa054&scoped=true&"
import script from "./orderDetail.vue?vue&type=script&lang=tsx&"
export * from "./orderDetail.vue?vue&type=script&lang=tsx&"
import style0 from "./orderDetail.vue?vue&type=style&index=0&id=7eefa054&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eefa054",
  null
  
)

export default component.exports